import { Platform } from "../constants";

import { SetupSection } from "./components/setup-section";
import { SubSubSectionHeader } from "./components/styled";
import { SubmitTicketButton } from "./components/submit-ticket-button";
import { type PlatformDetails } from "./platform-details";
import { UtmSpendAdditionalDetails } from "./utm-spend-details";

const PLATFORM = Platform.BLISS_POINT_MEDIA;

export const BlissPointMediaDetails: PlatformDetails = {
  northbeamDocUrl:
    "https://docs.northbeam.io/docs/tracking-for-bliss-point-media",
  officialDocUrl: "",
  additionalDetails: UtmSpendAdditionalDetails(PLATFORM),
};

export const BlissPointMediaSetup = () => (
  <>
    <SetupSection title="Get AWS access keys and S3 Bucket Name">
      <SubSubSectionHeader className="mb-2">
        Log into your Bliss Point Media account and find the following:
      </SubSubSectionHeader>
      <ul className="list-inside list-disc [&>li]:marker:text-xxs [&>li]:ml-2">
        <li>AWS Programmatic Access Keys</li>
        <li>S3 Bucket Name</li>
      </ul>
    </SetupSection>
    <SetupSection title="Submit ticket with your AWS Keys and S3 Bucket Name.">
      <p className="my-4 text-sm leading-tight">
        We'll plug this into our backend and enable our integration!
      </p>
      <SubmitTicketButton />
    </SetupSection>
  </>
);
